// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  npcId: __t.string().name("npc_id"),
  instanceId: __t.string().name("instance_id"),
  mapId: __t.string().name("map_id"),
  x: __t.i32(),
  y: __t.i32(),
  npcType: __t.string().name("npc_type"),
  metadataJson: __t.string().name("metadata_json"),
  despawnTick: __t.i64().name("despawn_tick"),
  createdAt: __t.timestamp().name("created_at"),
});
